// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as GuestRouteRouteImport } from './routes/_guest/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InvitationsAcceptRouteImport } from './routes/invitations/accept'
import { Route as GuestSignupRouteImport } from './routes/_guest/signup'
import { Route as GuestLoginRouteImport } from './routes/_guest/login'
import { Route as AuthDashboardRouteRouteImport } from './routes/_auth/dashboard/route'
import { Route as AuthProjectsNewRouteImport } from './routes/_auth/projects/new'
import { Route as AuthProjectsProjectIdRouteRouteImport } from './routes/_auth/projects/$projectId/route'
import { Route as AuthDashboardIndexRouteImport } from './routes/_auth/dashboard/index'
import { Route as AuthProjectsProjectIdIndexRouteImport } from './routes/_auth/projects/$projectId/index'
import { Route as AuthProjectsProjectIdSettingsRouteImport } from './routes/_auth/projects/$projectId/settings'
import { Route as AuthProjectsProjectIdImportRouteImport } from './routes/_auth/projects/$projectId/import'
import { Route as AuthProjectsProjectIdCitationsRouteImport } from './routes/_auth/projects/$projectId/citations'
import { Route as AuthProjectsProjectIdStatisticsIndexRouteImport } from './routes/_auth/projects/$projectId/statistics/index'
import { Route as AuthProjectsProjectIdDuplicatesIndexRouteImport } from './routes/_auth/projects/$projectId/duplicates/index'
import { Route as AuthProjectsProjectIdScreeningReviewRouteImport } from './routes/_auth/projects/$projectId/screening/review'
import { Route as AuthProjectsProjectIdScreeningAdjudicationRouteImport } from './routes/_auth/projects/$projectId/screening/adjudication'
import { Route as AuthProjectsProjectIdDuplicatesReviewRouteImport } from './routes/_auth/projects/$projectId/duplicates/review'
import { Route as AuthProjectsProjectIdScreeningTitleAbstractReviewRouteImport } from './routes/_auth/projects/$projectId/screening/title-abstract/review'
import { Route as AuthProjectsProjectIdScreeningTitleAbstractConflictsV3RouteImport } from './routes/_auth/projects/$projectId/screening/title-abstract/conflicts-v3'
import { Route as AuthProjectsProjectIdScreeningTitleAbstractConflictsV2RouteImport } from './routes/_auth/projects/$projectId/screening/title-abstract/conflicts-v2'
import { Route as AuthProjectsProjectIdScreeningTitleAbstractConflictsV1RouteImport } from './routes/_auth/projects/$projectId/screening/title-abstract/conflicts-v1'
import { Route as AuthProjectsProjectIdScreeningTitleAbstractConflictsRouteImport } from './routes/_auth/projects/$projectId/screening/title-abstract/conflicts'
import { Route as AuthProjectsProjectIdScreeningFullTextReviewRouteImport } from './routes/_auth/projects/$projectId/screening/full-text/review'
import { Route as AuthProjectsProjectIdScreeningFullTextConflictsRouteImport } from './routes/_auth/projects/$projectId/screening/full-text/conflicts'

const GuestRouteRoute = GuestRouteRouteImport.update({
            id: '/_guest',getParentRoute: () => rootRouteImport
          })
const AuthRouteRoute = AuthRouteRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const InvitationsAcceptRoute = InvitationsAcceptRouteImport.update({
            id: '/invitations/accept',path: '/invitations/accept',getParentRoute: () => rootRouteImport
          })
const GuestSignupRoute = GuestSignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => GuestRouteRoute
          })
const GuestLoginRoute = GuestLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => GuestRouteRoute
          })
const AuthDashboardRouteRoute = AuthDashboardRouteRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthRouteRoute
          })
const AuthProjectsNewRoute = AuthProjectsNewRouteImport.update({
            id: '/projects/new',path: '/projects/new',getParentRoute: () => AuthRouteRoute
          })
const AuthProjectsProjectIdRouteRoute = AuthProjectsProjectIdRouteRouteImport.update({
            id: '/projects/$projectId',path: '/projects/$projectId',getParentRoute: () => AuthRouteRoute
          })
const AuthDashboardIndexRoute = AuthDashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthDashboardRouteRoute
          })
const AuthProjectsProjectIdIndexRoute = AuthProjectsProjectIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdSettingsRoute = AuthProjectsProjectIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdImportRoute = AuthProjectsProjectIdImportRouteImport.update({
            id: '/import',path: '/import',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdCitationsRoute = AuthProjectsProjectIdCitationsRouteImport.update({
            id: '/citations',path: '/citations',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdStatisticsIndexRoute = AuthProjectsProjectIdStatisticsIndexRouteImport.update({
            id: '/statistics/',path: '/statistics/',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdDuplicatesIndexRoute = AuthProjectsProjectIdDuplicatesIndexRouteImport.update({
            id: '/duplicates/',path: '/duplicates/',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdScreeningReviewRoute = AuthProjectsProjectIdScreeningReviewRouteImport.update({
            id: '/screening/review',path: '/screening/review',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdScreeningAdjudicationRoute = AuthProjectsProjectIdScreeningAdjudicationRouteImport.update({
            id: '/screening/adjudication',path: '/screening/adjudication',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdDuplicatesReviewRoute = AuthProjectsProjectIdDuplicatesReviewRouteImport.update({
            id: '/duplicates/review',path: '/duplicates/review',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdScreeningTitleAbstractReviewRoute = AuthProjectsProjectIdScreeningTitleAbstractReviewRouteImport.update({
            id: '/screening/title-abstract/review',path: '/screening/title-abstract/review',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdScreeningTitleAbstractConflictsV3Route = AuthProjectsProjectIdScreeningTitleAbstractConflictsV3RouteImport.update({
            id: '/screening/title-abstract/conflicts-v3',path: '/screening/title-abstract/conflicts-v3',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdScreeningTitleAbstractConflictsV2Route = AuthProjectsProjectIdScreeningTitleAbstractConflictsV2RouteImport.update({
            id: '/screening/title-abstract/conflicts-v2',path: '/screening/title-abstract/conflicts-v2',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdScreeningTitleAbstractConflictsV1Route = AuthProjectsProjectIdScreeningTitleAbstractConflictsV1RouteImport.update({
            id: '/screening/title-abstract/conflicts-v1',path: '/screening/title-abstract/conflicts-v1',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdScreeningTitleAbstractConflictsRoute = AuthProjectsProjectIdScreeningTitleAbstractConflictsRouteImport.update({
            id: '/screening/title-abstract/conflicts',path: '/screening/title-abstract/conflicts',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdScreeningFullTextReviewRoute = AuthProjectsProjectIdScreeningFullTextReviewRouteImport.update({
            id: '/screening/full-text/review',path: '/screening/full-text/review',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })
const AuthProjectsProjectIdScreeningFullTextConflictsRoute = AuthProjectsProjectIdScreeningFullTextConflictsRouteImport.update({
            id: '/screening/full-text/conflicts',path: '/screening/full-text/conflicts',getParentRoute: () => AuthProjectsProjectIdRouteRoute
          })





const AuthDashboardRouteRouteChildren = {
  AuthDashboardIndexRoute: AuthDashboardIndexRoute
}

const AuthDashboardRouteRouteWithChildren = AuthDashboardRouteRoute._addFileChildren(AuthDashboardRouteRouteChildren)




const AuthProjectsProjectIdRouteRouteChildren = {
  AuthProjectsProjectIdCitationsRoute: AuthProjectsProjectIdCitationsRoute,AuthProjectsProjectIdImportRoute: AuthProjectsProjectIdImportRoute,AuthProjectsProjectIdSettingsRoute: AuthProjectsProjectIdSettingsRoute,AuthProjectsProjectIdIndexRoute: AuthProjectsProjectIdIndexRoute,AuthProjectsProjectIdDuplicatesReviewRoute: AuthProjectsProjectIdDuplicatesReviewRoute,AuthProjectsProjectIdScreeningAdjudicationRoute: AuthProjectsProjectIdScreeningAdjudicationRoute,AuthProjectsProjectIdScreeningReviewRoute: AuthProjectsProjectIdScreeningReviewRoute,AuthProjectsProjectIdDuplicatesIndexRoute: AuthProjectsProjectIdDuplicatesIndexRoute,AuthProjectsProjectIdStatisticsIndexRoute: AuthProjectsProjectIdStatisticsIndexRoute,AuthProjectsProjectIdScreeningFullTextConflictsRoute: AuthProjectsProjectIdScreeningFullTextConflictsRoute,AuthProjectsProjectIdScreeningFullTextReviewRoute: AuthProjectsProjectIdScreeningFullTextReviewRoute,AuthProjectsProjectIdScreeningTitleAbstractConflictsRoute: AuthProjectsProjectIdScreeningTitleAbstractConflictsRoute,AuthProjectsProjectIdScreeningTitleAbstractConflictsV1Route: AuthProjectsProjectIdScreeningTitleAbstractConflictsV1Route,AuthProjectsProjectIdScreeningTitleAbstractConflictsV2Route: AuthProjectsProjectIdScreeningTitleAbstractConflictsV2Route,AuthProjectsProjectIdScreeningTitleAbstractConflictsV3Route: AuthProjectsProjectIdScreeningTitleAbstractConflictsV3Route,AuthProjectsProjectIdScreeningTitleAbstractReviewRoute: AuthProjectsProjectIdScreeningTitleAbstractReviewRoute
}

const AuthProjectsProjectIdRouteRouteWithChildren = AuthProjectsProjectIdRouteRoute._addFileChildren(AuthProjectsProjectIdRouteRouteChildren)



const AuthRouteRouteChildren = {
  AuthDashboardRouteRoute: AuthDashboardRouteRouteWithChildren,AuthProjectsProjectIdRouteRoute: AuthProjectsProjectIdRouteRouteWithChildren,AuthProjectsNewRoute: AuthProjectsNewRoute
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(AuthRouteRouteChildren)




const GuestRouteRouteChildren = {
  GuestLoginRoute: GuestLoginRoute,GuestSignupRoute: GuestSignupRoute
}

const GuestRouteRouteWithChildren = GuestRouteRoute._addFileChildren(GuestRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRouteRoute: AuthRouteRouteWithChildren,GuestRouteRoute: GuestRouteRouteWithChildren,InvitationsAcceptRoute: InvitationsAcceptRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)